/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
function TestReportForm() {
  return (
    <main className="com_container p_test_report_form">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_18">
            시험 전후 상담보고서<span className="bar"></span>
            <span className="point_txt">등록</span>
          </h2>
          <section className="com_board_search">
            <article className="search">
              <input type="search" placeholder="학생명 검색" className="input s type_search" />
              <button className="com_btn gray ws s icon_search"></button>
            </article>
          </section>
        </section>
        <section className="com_pg_container">
          <section className="box box-1">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    <span> (고3ㆍ경기고등학교ㆍ본사) </span>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">과목</span>
                  <div className="cont">
                    <p className="txt">국어 l 2T </p>
                  </div>
                </div>
                <div className="info">
                  <span className="tit">10/35 회차 진행중</span>
                  <span className="cont">10/35 회차 진행중 </span>
                </div>
                <div className="info">
                  <span className="tit">교사</span>
                  <span className="cont com_blue_txt">김교사320</span>
                </div>
                <div className="info">
                  <span className="tit">담임</span>
                  <span className="cont com_blue_txt">김담임123</span>
                </div>
              </div>
            </div>
            <div className="com_board_box">
              <table className="com_board_list type_row">
                <colgroup>
                  <col width="148" />
                  <col width="auto" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>등록일</th>
                    <td>2022, 04, 12 ㅣ 12 : 30 </td>
                  </tr>
                  <tr>
                    <th>수업선택</th>
                    <td>
                      <select name="" id="" className="select">
                        <option value="수업선택">수업선택</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <th>학기</th>
                    <td>
                      <div className="check">
                        <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                        <label htmlFor="rdo01">1학기</label>
                        <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                        <label htmlFor="rdo02">2학기</label>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>시험</th>
                    <td>
                      <div className="check">
                        <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                        <label htmlFor="rdo03">모의고사</label>
                        <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                        <label htmlFor="rdo04">기말고사</label>
                        <input type="radio" name="rdo" id="rdo05" className="com_chk circle" />
                        <label htmlFor="rdo05">중간고사</label>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>과목 평균 점수</th>
                    <td>
                      <input type="text" className="input" placeholder="점수 입력" />
                    </td>
                  </tr>
                  <tr>
                    <th>등급</th>
                    <td>
                      <input type="text" className="input" placeholder="등급 입력" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          <section className="box">
            <div className="detail_tit dot">보고서 내용 입력</div>
            <div className="com_board_box">
              <div className="editer_area">에디터 영역</div>
            </div>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">등록</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default TestReportForm;
